<template>
  <div class="mt-10">
    <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
      회원 정품 인증시 입력 항목 추가
    </p>
    <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
      쇼핑몰에서 정품 인증시에 인증코드 입력 후 별도 필요한 정보를 입력받을 수
      있는 항목을 설정합니다.
    </p>

    <div class="row justify-center d-inline-block ml-0 mt-5" height="50px">
      <v-btn
        large
        color="grey darken-4"
        class="white--text"
        dense
        style="width:120px;"
        @click="addItems()"
        >+ 항목 추가</v-btn
      >
      <v-btn
        large
        color="grey darken-4"
        class="white--text ml-3"
        dense
        @click="addItems('marketing_agree')"
        >+ 마케팅 수신 동의 추가</v-btn
      >
    </div>

    <v-row>
      <v-col class="col-6 " sm="8" style="max-width: 780px;">
        <v-card outlined>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-default-header
            hide-default-footer
            class="elevation-1"
            item-key="id"
          >
            <template v-slot:[`item.text`]="{ item }" class="pl-0 pr-0">
              <div v-if="item.id == 0" class="pt-5 pb-3 pl-4">
                <v-text-field
                  v-model="item.text"
                  outlined
                  dense
                  hide-details
                  :placeholder="item.placeholder"
                  style="width:200px; float:left;"
                  class="mr-3"
                ></v-text-field>
                <v-select
                  v-model="item.type"
                  outlined
                  dense
                  hide-details
                  style="width:200px; float:left; background-color: #F6F6F6;"
                  class="mr-3"
                  disabled
                  :items="selectItems"
                  item-text="text"
                  item-value="value"
                  @change="selectChange(item)"
                ></v-select>

                <v-checkbox
                  v-model="item.require"
                  class="mt-0"
                  label="필수입력 여부"
                  disabled
                ></v-checkbox>
                <p
                  v-if="item.id == 0"
                  class="mb-0 mt-1 subtitle-2 font-weight-medium primary--text text-start"
                >
                  - 정품 보증 기간 설정에서 '고객 정품 구매일 기준'으로 설정되어
                  있습니다. 해당 항목 입력은 필수로 설정됩니다.
                </p>
              </div>
              <div v-else class="pt-5 pb-5 pl-4 pr-4">
                <div>
                  <v-text-field
                    v-model="item.text"
                    outlined
                    dense
                    hide-details
                    :placeholder="item.placeholder"
                    style="width:200px; float:left;"
                    class="mr-3"
                  ></v-text-field>
                  <v-select
                    v-if="item.is_marketing"
                    v-model="item.type"
                    outlined
                    dense
                    hide-details
                    placeholder="선택해주세요"
                    style="width:200px; float:left;background-color: #F6F6F6;"
                    class="mr-3"
                    :items="selectItems"
                    @change="selectChange(item)"
                    disabled
                  ></v-select>
                  <v-select
                    v-else
                    v-model="item.type"
                    outlined
                    dense
                    hide-details
                    placeholder="선택해주세요"
                    style="width:200px; float:left;"
                    class="mr-3"
                    :items="selectItems"
                    @change="selectChange(item)"
                  ></v-select>
                  <v-checkbox
                    v-model="item.require"
                    class="mt-0"
                    label="필수입력 여부"
                    style="float:left;"
                  ></v-checkbox>

                  <v-btn
                    large
                    height="40px"
                    style="width:100px; float: right;"
                    width="100"
                    hide-details
                    @click="delItems(item)"
                    class="mb-5"
                    >삭제</v-btn
                  >
                </div>

                <div
                  v-if="
                    (item.type == 'checkbox' || item.type == 'select') &&
                      !item.is_marketing
                  "
                >
                  <div
                    v-for="(optionItem, index) in item.option"
                    :key="optionItem.id"
                    class="ml-5"
                    style="float: left; width:350px;"
                  >
                    <v-row v-if="index == 0">
                      <v-icon
                        v-if="item.type == 'checkbox'"
                        class="mr-3 mb-2 pb-1"
                        size="20"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon v-else class="mr-3 mb-2 pb-1" size="20"
                        >mdi-check</v-icon
                      >
                      <v-text-field
                        v-model="optionItem.text"
                        dense
                        hide-details
                        placeholder="옵션명 입력"
                        style="max-width:200px; float:left; font-size:14px;"
                        class="mr-3 mb-5"
                      ></v-text-field>
                      <v-btn
                        v-if="index == 0"
                        small
                        color="grey darken-4 ml-2"
                        class="white--text ml-0 mr-0 pl-4 pr-4 pr-0 mt-1"
                        @click="optionItemsAdd(item)"
                        >옵션추가</v-btn
                      >
                    </v-row>

                    <v-row v-else>
                      <v-icon
                        v-if="item.type == 'checkbox'"
                        class="mr-3 mb-2 pb-1"
                        size="20"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon v-else class="mr-3 mb-2 pb-1 " size="20"
                        >mdi-check</v-icon
                      >
                      <v-text-field
                        v-model="optionItem.text"
                        dense
                        hide-details
                        placeholder="옵션명 입력"
                        style="max-width:200px; float:left; float:left; font-size:14px;"
                        class="mr-3 mb-5"
                      ></v-text-field>
                      <v-icon
                        @click="delOptionItems(item, optionItem)"
                        style="cursor:pointer;"
                        class="pb-1"
                        >mdi-close-thick</v-icon
                      >
                    </v-row>
                  </div>
                </div>
                <!-- 마케팅 동의 영역 -->
                <div v-if="item.is_marketing">
                  <v-row class="col-12 pa-0 mx-0">
                    <div class="col-12 pa-0">
                      <v-textarea
                        outlined
                        hide-details
                        no-resize
                        v-model="item.marketing_info"
                      ></v-textarea>
                    </div>
                  </v-row>
                  <div
                    v-for="optionItem of item.option"
                    :key="optionItem.id"
                    class="d-inline-block col py-0 px-2"
                  >
                    <v-row class="d-block mb-0 mt-4">
                      <v-icon class="mr-3 mt-4 float-left" size="20"
                        >mdi-check-circle</v-icon
                      >
                      <v-text-field
                        v-model="optionItem.text"
                        dense
                        hide-details
                        placeholder="옵션명 입력"
                        style="max-width:200px; float:left; font-size:14px; margin-right:14px;"
                        class="mt-3"
                      ></v-text-field>
                      <v-select
                        v-model="item.marketing_type"
                        outlined
                        dense
                        hide-details
                        placeholder="선택해주세요"
                        style="width:210px;"
                        :items="marketing_items"
                      ></v-select>
                    </v-row>
                  </div>
                </div>
              </div>
            </template>
            <template slot="no-data">
              <div class="noDataProductInfos">항목을 추가해주세요.</div>
            </template>
          </v-data-table>
        </v-card>
        <div class="row justify-center mt-10">
          <v-btn
            large
            color="primary"
            class="saveBtn"
            style="width:200px"
            @click="saveAuthItems()"
            >저장</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data: () => ({
    M,
    AUTH_SERVICE,
    headers: [
      {
        text: "text",
        align: "center",
        sortable: false,
        value: "text",
      },
    ],
    items: [
      {
        id: 0,
        text: "구매일자",
        type: "date",
        require: true,
        option: [],
      },
    ],
    selectItems: [
      {
        text: "텍스트 입력",
        value: "text",
      },
      {
        text: "드롭다운 선택",
        value: "select",
      },
      {
        text: "체크박스 선택",
        value: "checkbox",
      },
      {
        text: "파일 업로드",
        value: "file",
      },
      {
        text: "날짜 선택 (년/월/일)",
        value: "date",
      },
    ],
    duration_type: "",
    marketing_type: "enabled",
    marketing_items: [
      {
        text: "체크 상태로 노출",
        value: "enabled",
      },
      {
        text: "미체크 상태로 노출",
        value: "disabled",
      },
    ],
    marketing_info:
      "개인정보보호법 제22조 제4항에 의해 선택정보 사항에 대해서는 기재하지 않으셔도 서비스를 이용하실 수 있습니다.\n\n① 마케팅 및 광고에의 활용신규 서비스(제품) 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.\n② 000는 서비스를 운용함에 있어 각종 정보를 서비스 화면, 전화, e-mail, SMS, 우편물,앱 푸쉬 등의 방법으로 회원에게 제공할 수 있으며, 마일리지 적립 및 소진/소멸 등, 의무적으로 안내되어야 하는 정보성 내용은 수신동의 여부와 무관하게 제공됩니다.\n\n이 약관은 0000년 00월 00일부터 시행합니다.",
  }),

  mixins: [CommonMixin],
  methods: {
    addItems: function(type) {
      let lastItem = {
        id: 0,
      };
      if (this.items.length > 0) {
        lastItem = this.items[this.items.length - 1];
      }
      let setData = {
        id: lastItem.id + 1,
        text: "",
        type: "text",
        require: false,
        option: [
          {
            id: 0,
            text: "",
          },
        ],
        placeholder: "항목명 입력",
        is_marketing: false,
        marketing_type: "disabled",
      };
      if (type == "marketing_agree") {
        setData.type = "checkbox";
        setData.placeholder = "마케팅 수신 동의";
        setData.is_marketing = true;
        setData.option = [
          {
            id: 0,
            text: "동의합니다",
          },
        ];
        setData.marketing_type = "enabled";
        setData.marketing_info = this.marketing_info;
      }
      this.items.push(setData);
    },
    delItems: function(v) {
      const idx = this.items.indexOf(v);
      if (idx > -1) {
        this.items.splice(idx, 1);
      }
    },
    optionItemsAdd: function(v) {
      let id = v.option[v.option.length - 1].id + 1;

      v.option.push({ id: id, text: "" });
    },
    delOptionItems: function(v, item) {
      const idx = v.option.indexOf(item);
      if (idx > -1) {
        v.option.splice(idx, 1);
      }
    },
    selectChange: function(v) {
      v.option = [
        {
          id: 0,
          text: "",
        },
      ];
    },
    /**
     * 데이터 가져오기
     */
    getDuration: async function() {
      let data = await M.api(M.entry("/get/duration"), {});

      if (data) {
        this.duration_type = data.duration_type;
        if (data.duration_type !== "bought") {
          this.items = [];
        } else {
          this.items = [];
        }
      }
    },
    /**
     * 정품 인증 관리자 승인 설정 조회
     */
    getAuthItems: async function() {
      let data = await M.api(M.entry("/get/config/authItems"), {});

      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (this.duration_type == "bought") {
            if (i === 0) {
              if (data[i].id > 0) {
                this.items.push({
                  id: 0,
                  text: "구매일자",
                  type: "date",
                  require: true,
                });
              } else {
                let setData = {
                  id: 0,
                  text: data[i].text,
                  type: data[i].type,
                  require: data[i].require,
                  option: data[i].option,
                };

                this.items.push(setData);
                continue;
              }
            }
          }
          if (this.duration_type != "bought" && i === 0 && data[i].id === 0) {
            continue;
          }

          let setData = {
            id: data[i].id + 1,
            text: data[i].text,
            type: data[i].type,
            require: data[i].require,
            option: data[i].option,
            placeholder: data[i].placeholder,
            is_marketing: data[i].is_marketing,
            marketing_type: data[i].marketing_type,
            marketing_info: data[i].marketing_info,
          };

          this.items.push(setData);
        }
      } else {
        if (this.duration_type == "bought") {
          this.items.push({
            id: 0,
            text: "구매일자",
            type: "date",
            require: true,
          });
        }
      }
    },

    /**
     * 정품 인증 항목 설정
     */
    saveAuthItems: async function() {
      if (this.items.length == 0) {
        this.alertShow("추가하신 항목이 없습니다.");
        return false;
      }

      for (let i = 0; i < this.items.length; i++) {
        if (!this.items[i].text) {
          this.alertShow("항목명을 입력해주세요.");
          return false;
        }
      }

      try {
        await M.api(M.entry("/post/config/authItems"), this.items);
        this.alertShow("저장되었습니다.");
      } catch (e) {
        this.alertShow("정품 인증 관리자 승인 설정을 저장하지 못했습니다.");
      }
    },
    /**
     * 정품 인증 항목 설정
     */
    getApproval: async function() {
      try {
        let data = await M.api(M.entry("/get/config/approval"), {});

        if (data) {
          this.approval = data.status;
        }
      } catch (e) {
        //console.log(e);
      }
    },
    reSearch: async function() {
      await this.getDuration();
      await this.getAuthItems();
    },
  },
  created: async function() {
    this.eventHub.$on("setList", this.reSearch);
    await this.reSearch();
    //await this.getAuthItems();
  },
};
</script>
